import UpdateAction from "./UpdateAction.js";
import CreateAction from "./CreateAction.js";
import PauseFirmwareRelease from "./firmwareRelease/PauseFirmwareRelease.js";
import ResumeFirmwareRelease from "./firmwareRelease/ResumeFirmwareRelease.js";
import StopFirmwareRelease from "./firmwareRelease/StopFirmwareRelease.js";
import ReleaseFirmware from "./deviceGroup/ReleaseFirmware.js";
import DeleteAction from "./DeleteAction.js";
const install = molten => {
  molten.addPlugin('Action', CreateAction);
  molten.addPlugin('Action', UpdateAction);
  molten.addPlugin('Action', DeleteAction);
  molten.addPlugin('Action', PauseFirmwareRelease);
  molten.addPlugin('Action', ResumeFirmwareRelease);
  molten.addPlugin('Action', StopFirmwareRelease);
  molten.addPlugin('Action', ReleaseFirmware);
};
export { install };
export default {
  install
};